/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Type_ColumnInputs */

const en_knp_lookup_type_column = /** @type {(inputs: Knp_Lookup_Type_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const fr_knp_lookup_type_column = /** @type {(inputs: Knp_Lookup_Type_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_knp_lookup_type_column = /** @type {(inputs: Knp_Lookup_Type_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

const it_knp_lookup_type_column = /** @type {(inputs: Knp_Lookup_Type_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const ru_knp_lookup_type_column = /** @type {(inputs: Knp_Lookup_Type_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип`)
};

const es_knp_lookup_type_column = /** @type {(inputs: Knp_Lookup_Type_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

const zh_cn2_knp_lookup_type_column = /** @type {(inputs: Knp_Lookup_Type_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const ja_knp_lookup_type_column = /** @type {(inputs: Knp_Lookup_Type_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイプ`)
};

const hi_knp_lookup_type_column = /** @type {(inputs: Knp_Lookup_Type_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रकार`)
};

const pt_pt2_knp_lookup_type_column = /** @type {(inputs: Knp_Lookup_Type_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Knp_Lookup_Type_ColumnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_type_column = /** @type {((inputs?: Knp_Lookup_Type_ColumnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Type_ColumnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_type_column(inputs)
	if (locale === "de") return de_knp_lookup_type_column(inputs)
	if (locale === "it") return it_knp_lookup_type_column(inputs)
	if (locale === "ru") return ru_knp_lookup_type_column(inputs)
	if (locale === "es") return es_knp_lookup_type_column(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_type_column(inputs)
	if (locale === "ja") return ja_knp_lookup_type_column(inputs)
	if (locale === "hi") return hi_knp_lookup_type_column(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_type_column(inputs)
	return en_knp_lookup_type_column(inputs)
});